if (process.env.NODE_ENV==='development') {
  require("preact/debug");
}

import {h, render} from 'preact';
import 'babel-polyfill';
import DebtsForm from "./components/debts/Form";
import DetailsForm from "./components/details/Form";
import ApartmentForm from "./components/apartmentForm/ApartmentForm";

window.reactRenderDebtsForm = function(node, props){
	render(<DebtsForm {...props}/>, node);
};

window.reactRenderDetailsForm = function(node, props){
	render(<DetailsForm {...props}/>, node);
};

if (document.getElementById('preact-apartment-form') !== null) {
	window.reactRenderApartmentForm = function(node, props){
		render(<ApartmentForm {...props}/>, node);
	};
}